<template>
  <div class="row" style="margin-top: 20px">
    <div class="col-md-12">
      <div class="card padmain">
        <h4>1. HOW TO CREATE TOURNAMENT</h4>
        <div class="headtxt">
          <span>
            <span>&starf;</span> Select “Tournaments” from the dashboard &
            choose Create Tournaments .</span
          >
          <br />
          <span>
            <span>&starf;</span> Choose from wide range of the games and fill up
            the requisite details to create the tournament
          </span>
        </div>
        <br>
        <div style="padding-left: 35px">
          <div>
            <h5>1.1 Tournament Name, Live Time & End time</h5>
            <div class="contentsiz">
              <span>&starf;</span> <b>Tournament Name</b> - The user can
              customise the name of the tournament as per his/her choice. We
              recommend choosing a suitable name which goes along with the game.
              <br />

              <span>&starf;</span> <b>Tournament Live Time</b> - Select the time
              when the tournament has to go live, make sure that tournament is
              being held within 3 days from the time you create the tournament.
              In case, a future time and date is chosen for the tournament, it
              will appear in the upcoming section.<br />

              <span>&starf;</span> <b>Tournament End Time</b> - This will denote
              the end of the tournament, users can choose to end the tournament
              as early as 5 mnts or stretch it to 6 hours from the Live Time.
              <br />
            </div>
          </div>
          <br />
          <div>
            <h5>1.2 Enter Number of Participants</h5>
            <div class="contentsiz">
              <span>&starf;</span> <b>Maximum Players/Participants</b> - The
              maximum number of players allowed to participate in the
              tournament.
            </div>
          </div>

          <div>
            <br />
            <h5>1.3 Creator Fee, Platform Fee & Pool Distribution</h5>
            <div class="contentsiz">
              <span>&starf;</span> <b>Creator Fee</b> - The user who creates the
              tournaments will receive 15% of the total prize pool <br />

              <span>&starf;</span> <b>Platform Fee</b> - The Platform fee will
              be always 5% regardless of the total pool size. <br />

              <span>&starf;</span> <b>Pool Distribution </b> - The Pool
              Distribution to the winners will be in the ratio of 80:20, where
              80% would be distributed to the winners. The Creator can choose to
              set the winning ratio as per his/her choice. For example: If a
              user wants to share the prize pool b/w 3 players, he can choose to
              distribute 40% to Rank 1, 30% to Rank 2 & 10% to Rank 3.
            </div>
          </div>
          <br />
          <div>
            <h5>
              1.4 Tournament Rules, Rewards Distribution Message & Winner
              Message
            </h5>
            <div class="contentsiz">
              <span>&starf;</span> <b>Tournament Rules</b> - The user can create
              a set of rules that will be displayed to the participants prior to
              entering the tournament. Here is the tournament rules template
              which could be used <br />

              <span>&#x2022;</span> Put your participation slots early in
              tournaments that are listed under "Upcoming" to join with a
              minimum entry fee amount. <br />
              <span>&#x2022;</span> You will be notified once the tournaments
              that are listed under "Upcoming" go "Live". <br />
              <span>&#x2022;</span> Pay the entry fees once and play as many
              times as you wish until the contest countdown ends. <br />
              <span>&#x2022;</span> Hesitation is Defeat! Keep playing to reach
              the top position in the leaderboard. <br />
              <span>&#x2022;</span> Check your prize and ranking once the
              tournament is "Completed". <br />

              <span>&starf;</span> <b>Tournament Rules</b> - The rewards
              distribution message will appear to the participant on the
              tournament tab.<br />
              Template: Pay with __ Rage(token name) and win up to __ Rage(token
              name). Total prize pool will be distributed based on your position
              in the leaderboard. <br />

              <span>&starf;</span> <b>Winner Message</b>- The Winner Message
              will appear on the leaderboard, and will be visible to the
              participants.

              <br />
              Template: Home is where you are 'Rank 1'. Keep playing tournaments
              to enhance your gaming skill and surpass your own score to reach
              top positions in the leaderboard.
            </div>
            <br />
          </div>
        </div>
        <!-- <div v-for="(items, index) in instruction" :key="index">
          <h5 class="headpad">{{ index + 1 }}) {{ items.heading }}</h5>
          <div class="headtxt">
            <span>
                <span>&check;</span> {{ items.content }}
            </span>
          </div>
        </div> -->
      </div>
    </div>

    <div class="col-md-12">
      <div class="card padmain">
        <h4>2. HOW TO CHECK CREATED TOURNAMENTS ?</h4>
        <div>
            <div class="headtxt">
          <span>&starf;</span> Users can view all the tournaments under
          “Tournament List”. Users can edit their tournament until there are no
          participants.Users can view the details of users who are participating
          in the tournament and also have access to the leaderboard.</div>
        </div>
        <br>
        <h4>TERMS & CONDITIONS</h4>
        <div v-for="(items, index) in limitation" :key="index">
          <div class="headtxt">
            <span> <span>&check;</span> {{ items }} </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      instruction: [
        {
          heading: "Set a Tournament start time, Live Time and End time.",
          content:
            "Start by setting a “Name” for your Tournament. Set a “Tournament Live Time” of when you want your tournament to go live. Make sure it's within 3 days from the date you upload the tournament. Users will be able to view your tournament as “Upcoming” and the time of when the tournament will go Live. Choosing “NOW” will instantly let your tournament go “Live”. Users can set any “Tournament End Time” which is when you want your tournament to end. Make sure it's within 6hrs from the “Tournament Live Time”. Users can set exciting tournaments from 5mins - 6 hrs from Live Time, and share it among their friends to compete against each other.",
        },
        {
          heading: "Set Minimum players?",
          content:
            "Maximum player limit is how many users you want to participate in your tournament. Once the maximum number of players pay the fee and join the tournament, then no new players can join furthermore. A full-fledged tournament is thrilling only when all the slots get filled.",
        },
        {
          heading: "Set Prize Distribution Creator Fee & Platform Fee",
          content:
            "A user who creates a tournament will receive 15% from the total paid fee and the platform fee will be 5%. The 80% should be shared among the users based on how a creator wants to distribute it. Creators will be allowed to set their own desired number of winners and distribution percentage. Eg: If you want 3 winners to share the 80% win pool, then setting 40% for Rank #1 winner, 30% for Rank #2 winner and 10% for Rank #3 winners would be one way of distributing it.",
        },
        {
          heading: "Set Rules, Reward and Winning Message",
          content:
            "Users can type in Rules that they want to set for their created game Tournament. Eg, How long will the tournament be Live, if it's either 5 min short tournament, or 5hr tournament. Users can communicate with their contestants through Reward Message and Win Message. 'Reward Message' will appear before the user enters a tournament and the 'Winning Message' will appear in the leaderboard table.",
        },
        {
          heading: "Check your Created Tournaments.",
          content:
            "Users can view all the tournaments they create under “Tournament List”. Users can edit their tournament when there is no user participation. Users will not be allowed to edit their tournament even if there is 1 participant joined. Users can view the details of users who are participating in the tournament and also check the leaderboard for Rank.",
        },
      ],
      limitation: [
       "Only 1 Game can run at a point of time- User will be allowed to create the tournament for the same game after the previous game has ended",
       "The Tournament can go live within 3 days, and it can run till 6 hours from the set Live Time.",
       "A user can create a maximum of 3 gaming tournaments per day.",
       " Users will not be allowed to edit the tournament once the participant has reserved his slot.",
       "The user can set the distribution percentage, i.e 80% to be distributed amongst the winners.",
       "Tournament will not get cancelled even if there is 1 participant."
      ],
    };
  },
};
</script>
  <style>
.headtxt {
  text-align: justify;
  font-size: 14px;
  font-weight: 400;
  padding: 12px;
  line-height: 20px;
  font-style: normal;
}
.padmain {
  padding: 20px;
  line-height: 20px;
  font-style: normal;
}
.headpad {
  padding: 10px;
  line-height: 20px;
  font-style: normal;
  font-weight: 600;
  /* text-shadow: 0.1px 0.1px black; */
}
.contentsiz {
  line-height: 25px;
}
</style>